import { RiveFileType } from '@/hooks';
import { ShapeBaseAttribute } from './base';
export class RiveAttribute extends ShapeBaseAttribute {
  // 普通rive文件
  riveFile?: string;
  // 图片或字体文件
  riveResources?: string[];
  riveDiranme?: string;
  interactiveState?: boolean;

  /** 高级rive文件 Android系统使用 */
  riveFileExt?: string;
  // 图片或字体文件
  riveResourcesExt?: string[];
  riveDiranmeExt?: string;
  interactiveStateExt?: boolean;

  riveToShow?: RiveFileType = 'normal';

  riveFileCounts?: number = 1;

  resources: {
    rivePreview?: LayerResourceItem;
  } = {};
}
